//
//
//
//
//
//
//
//
//

export default {
  name: 'legal-agreement-content',
  props: {
    agreement: {
      type: Object,
      required: true,
    },
  },
  computed: {
    updatedAt() {
      return this.$date(this.agreement.updatedAt).formatLocalized('PPP');
    },
  },
};
